module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.isAdmin) ? _c('div', {
    staticClass: "container page-container",
    attrs: {
      "id": "profile-form"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('h1', [_vm._v("Add a User")]), _vm._v(" "), _c('el-form', {
    ref: "addUserForm",
    staticClass: "ruleForm",
    attrs: {
      "model": _vm.addUserForm,
      "rules": _vm.rules,
      "label-position": _vm.labelPosition,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addUserForm.email),
      callback: function($$v) {
        _vm.addUserForm.email = $$v
      },
      expression: "addUserForm.email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.addUserForm.pass),
      callback: function($$v) {
        _vm.addUserForm.pass = $$v
      },
      expression: "addUserForm.pass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.submitForm('addUserForm')
      }
    }
  }, [_vm._v("Add User")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('h1', [_vm._v("Manage Users")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('el-col', {
      key: user.email,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 12,
        "lg": 12
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "text item"
    }, [_c('span', {
      staticClass: "user-title"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/users/' + user['.key'])
        }
      }
    }, [_vm._v("Manage")]), _vm._v(" "), _c('div', {
      staticClass: "cf"
    }), _vm._v(" "), (user.isAdmin !== false) ? _c('span', {
      staticClass: "edited"
    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (user.isAdmin == false) ? _c('span', {
      staticClass: "edited"
    }, [_vm._v("Client")]) : _vm._e()], 1)])], 1)
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-197208f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = 331
// module chunks = 2